<template>
  <SmartLinkStandaloneElement
    v-if="model"
    :codename="contentTypes.call_to_action.elements.link_title.codename"
  >
    <NuxtLink :class="buttonStyle" :target="targetName(model)" :to="ctaLink">
      {{ model?.elements?.link_title?.value }}
      <IconArrowRightLong v-if="buttonStyle === 'btn btn-link'" class="arrow-icon" />
    </NuxtLink>
  </SmartLinkStandaloneElement>
</template>

<script lang="ts" setup>
import { useCtaLink } from '~~/app/composables/useCtaLink'
import { useCtaTarget } from '~~/app/composables/useCtaTarget'
import type { CallToActionModel } from '~~/app/models'
import { contentTypes } from '~~/app/models'

const props = defineProps<{
  model: CallToActionModel
  customTarget?: string
}>()

const ctaLink = ref<string>('')
if (props.model) {
  useCtaLink(props.model).then((url: string) => {
    ctaLink.value = url
  })
}

function targetName(cta: CallToActionModel) {
  return props.customTarget ? props.customTarget : useCtaTarget(cta)
}

const buttonStyle = computed(() => {
  switch (firstOrDefault(props.model.elements.styling_options.value)?.codename) {
    case contentTypes.call_to_action.elements.styling_options.options.button.codename:
      return 'btn btn-orange'
    case contentTypes.call_to_action.elements.styling_options.options.text_w__arrow.codename:
      return 'btn btn-link'
    default:
      return 'btn btn-orange'
  }
})
</script>
